<!-- 顶部提示 -->
<template>
  <transition name="drop">
    <div class="top-tip"
      v-show="showFlag"
      @click.stop="hide">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    delay: {
      type: Number,
      default: 2500
    }
  },
  data () {
    return { showFlag: false }
  },
  methods: {
    show () {
      this.showFlag = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.hide()
      }, this.delay)
    },
    hide () {
      this.showFlag = false
    }
  }
}
</script>

<style scoped lang="less">
.top-tip {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 500;
  font-size: 28/200rem;
  text-align: center;
  padding: 15/200rem;
  color: #fff;
  background: rgba(239, 167, 35, 0.95);

  &.drop-enter-active,
  &.drop-leave-active {
    transition: all 0.5s;
  }
  &.drop-enter,
  &.drop-leave-to {
    transform: translate3d(0, -100%, 0);
  }
}
</style>
